import { HttpBackend } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { environment } from '../../../environments/environment';

// AoT requires an exported function for factories
export function HttpLoaderFactory(_httpBackend: HttpBackend) {
  return new MultiTranslateHttpLoader(_httpBackend, [
    { prefix: './i18n/common/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/errors/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/forms/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/sign-in/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/benefit-layout/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-layout/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-home/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-profile/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-wallet/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-top-up/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-send-credits/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-create-contact/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/hcp-registration/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/plans/', suffix: `.json?v=${environment.appVersion}` },
  ]);
}
